export const FETCH_STORIES_BY_USER_REQUEST = "FETCH_STORIES_BY_USER_REQUEST";
export const FETCH_STORIES_BY_USER_SUCCESS = "FETCH_STORIES_BY_USER_SUCCESS";
export const FETCH_STORIES_BY_USER_FAIL = "FETCH_STORIES_BY_USER_FAIL";

export const CREATE_STORY_REQUEST = "CREATE_STORY_REQUEST";
export const CREATE_STORY_SUCCESS = "CREATE_STORY_SUCCESS";
export const CREATE_STORY_FAIL = "CREATE_STORY_FAIL";

export const DELETE_STORY_REQUEST = "DELETE_STORY_REQUEST";
export const DELETE_STORY_SUCCESS = "DELETE_STORY_SUCCESS";
export const DELETE_STORY_FAIL = "DELETE_STORY_FAIL";

export const UPLOAD_STORY_MEDIA_REQUEST = "UPLOAD_STORY_MEDIA_REQUEST";
export const UPLOAD_STORY_MEDIA_SUCCESS = "UPLOAD_STORY_MEDIA_SUCCESS";
export const UPLOAD_STORY_MEDIA_FAIL = "UPLOAD_STORY_MEDIA_FAIL";

export const RESET_STORIES_ERROR = "RESET_STORIES_ERROR";

export const FETCH_HIGHLIGHTS_BY_USER_REQUEST =
  "FETCH_HIGHLIGHTS_BY_USER_REQUEST";
export const FETCH_HIGHLIGHTS_BY_USER_SUCCESS =
  "FETCH_HIGHLIGHTS_BY_USER_SUCCESS";
export const FETCH_HIGHLIGHTS_BY_USER_FAIL = "FETCH_HIGHLIGHTS_BY_USER_FAIL";

export const CREATE_HIGHLIGHT_REQUEST = "CREATE_HIGHLIGHT_REQUEST";
export const CREATE_HIGHLIGHT_SUCCESS = "CREATE_HIGHLIGHT_SUCCESS";
export const CREATE_HIGHLIGHT_FAIL = "CREATE_HIGHLIGHT_FAIL";

export const UPDATE_HIGHLIGHT_REQUEST = "UPDATE_HIGHLIGHT_REQUEST";
export const UPDATE_HIGHLIGHT_SUCCESS = "UPDATE_HIGHLIGHT_SUCCESS";
export const UPDATE_HIGHLIGHT_FAIL = "UPDATE_HIGHLIGHT_FAIL";

export const DELETE_HIGHLIGHT_REQUEST = "DELETE_HIGHLIGHT_REQUEST";
export const DELETE_HIGHLIGHT_SUCCESS = "DELETE_HIGHLIGHT_SUCCESS";
export const DELETE_HIGHLIGHT_FAIL = "DELETE_HIGHLIGHT_FAIL";

export const ADD_STORY_TO_HIGHLIGHT_REQUEST = "ADD_STORY_TO_HIGHLIGHT_REQUEST";
export const ADD_STORY_TO_HIGHLIGHT_SUCCESS = "ADD_STORY_TO_HIGHLIGHT_SUCCESS";
export const ADD_STORY_TO_HIGHLIGHT_FAIL = "ADD_STORY_TO_HIGHLIGHT_FAIL";
